import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { seleccionarPhoto } from '../../helpers/perfil'
import { useForm } from '../../hooks/ useForm'
import { updatePhotoPerfil } from '../../reducer/PerfilReducer'
import Loading from '../tools/Loading'

const ImgPerfil = ({photoURL, email}) => {
    const dispatch = useDispatch()
    const [edit, setEdit] = useState(false)
    const [loading, setLoading] = useState(false)
    const [values, handleInputChange] = useForm({img: ''})
    const {img} = values
    const handlePhotoPerfil = () => {
        setLoading(true)
        seleccionarPhoto(img, email)
        .then(() => {
            const url = URL.createObjectURL(img);
            dispatch(updatePhotoPerfil(url))
            setLoading(false)
            setEdit(false)
        })
    }
    return (
        <>
        
            <figure>
                <img src={photoURL} alt='Logo' />
            </figure>
            <div className='cont_perfil_controls'>
                {
                    edit
                    ?
                        loading
                        ? <Loading />
                        :
                            <>
                                <input
                                    type='file'
                                    name='img'
                                    onChange={handleInputChange}
                                />
                                <button className='btn_success'
                                    onClick={() => handlePhotoPerfil()}
                                >Guardar</button>
                                <button className='btn_danger' onClick={() => setEdit(!edit)}>Cancelar</button>
                            </>
                    : <button className='btn_info' onClick={() => setEdit(!edit)}>Editar</button>
                }
                
                
            </div>
        </>
    )
}

export default ImgPerfil
